import SocialContext from "./SocialContext";
import { useState } from "react";
import { useNavigate } from "react-router";
import axiosInstance from '../config';
import axios from "axios";
// const host = "http://localhost:5000/api/";

const SocialStateContext = (props) => {
    const navigate = useNavigate();

    // user 
    const [user, setuser] = useState({});

    const [isfetching, setisfetching] = useState(0);
    const [iserror, setiserror] = useState(0);

    // login function
    const loginfun = async (email, password) => {
        setisfetching(1);
        try {
            const usercredentials = {
                "email": email,
                "password": password,
            }

            // fetch user
            const res = await axiosInstance.post("/api/auth/login", usercredentials);
            // console.log("inside loginfun", res.data);
            setisfetching(0);
            setiserror(0);

            if (res.data.success) {
                // To store data
                // console.log(res.data, " and uid is => ", res.data._id);
                window.localStorage.setItem('currentUID', res.data.user._id);
                // console.log(window.localStorage.getItem("currentUID"));

                setuser(res.data.user);
                navigate('/');
            } else {
                setshowalert(true);
                setalertType('warning');
                setalertmessage("Invalid login credentials");
                setTimeout(() => {
                    setshowalert(false);
                }, 2000);
            }
        } catch (error) {
            // console.log("inside loginfun 2", error);
            setTimeout(() => {
                setisfetching(0);
            }, 2000);
            setiserror(1);
            // console.log(error);
        }
    }



    // register function
    const registerfun = async (username, email, password) => {
        setisfetching(1);
        try {
            const usercredentials = {
                "username": username,
                "email": email,
                "password": password,
            }
            const res = await axiosInstance.post("/api/auth/register", usercredentials);
            if (res.data.success) {
                setshowalert(true);
                setalertType('success');
                setalertmessage("You are registered successfully");
                setTimeout(() => {
                    setshowalert(false);
                }, 2000);
                setisfetching(0);
                navigate('/login');
            } else {
                setshowalert(true);
                setalertType('warning');
                setalertmessage(res.data.message);
                setisfetching(0);
                setTimeout(() => {
                    setshowalert(false);
                }, 5000);
            }
        } catch (error) {
            console.log("inside register ", error);
            setisfetching(0);
            setiserror(1);
        }
    }



    // for fetch current user
    const fetchcurrentuserfun = async (uid) => {
        if (window.localStorage.getItem('currentUID')) {
            try {
                const id = window.localStorage.getItem('currentUID');
                const response = await axiosInstance.get(`/api/users?userId=${id}`);
                setuser(response.data);
            } catch (error) {
                console.log("Inside fetchuserfun", error);
            }
        }
    }

    // function for logout
    const logoutfun = async () => {
        try {
            setuser({});
            window.localStorage.removeItem("currentUID");
            navigate('/feedback');
        } catch (error) {
            console.log("inside login fun", error);
        }
    }

    // scroll to function
    const scrolltoTopfun = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    // -------------------- for shoalert -------------------
    const [showalert, setshowalert] = useState(false);
    const [alertmessage, setalertmessage] = useState("");
    const [alertType, setalertType] = useState("success");

    // ------------------ for conform action ---------------
    const [open, setOpen] = useState(false);
    const [conformMessage, setconformMessage] = useState("");
    const [conformAction, setconformAction] = useState("");
    // ---------- for conform post delete
    const [deletePostID, setdeletePostID] = useState(false);

    // ---------- state for count of number of unread notification -----------
    const [unreadnotification, setunreadnotification] = useState(0);
    const countunreadnotification = async () => {
        const userid = window.localStorage.getItem('currentUID');
        if (window.localStorage.getItem('currentUID')) {
            const response = await axiosInstance.get('/api/notification/countunreadnotification/' + userid);
            setunreadnotification(response.data);
        }
    }

    return (
        <SocialContext.Provider value={{countunreadnotification, unreadnotification, setunreadnotification, setdeletePostID, deletePostID, conformAction, setconformAction, conformMessage, setconformMessage, open, setOpen, alertType, setalertType, setalertType, showalert, setshowalert, alertmessage, setalertmessage, user, scrolltoTopfun, logoutfun, isfetching, iserror, fetchcurrentuserfun, setiserror, setisfetching, setuser, loginfun, registerfun }}>
            {props.children}
        </SocialContext.Provider>
    )
}

export default SocialStateContext;